
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/collectibles",
      function () {
        return require("private-next-pages/[locale]/collectibles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/collectibles"])
      });
    }
  